var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4179 6.70588H10.7143V1.11765C10.7143 0.502941 10.2321 0 9.64286 0H5.35714C4.76786 0 4.28571 0.502941 4.28571 1.11765V6.70588H2.58214C1.62857 6.70588 1.14643 7.91294 1.82143 8.61706L6.73929 13.7471C7.15714 14.1829 7.83214 14.1829 8.25 13.7471L13.1679 8.61706C13.8429 7.91294 13.3714 6.70588 12.4179 6.70588ZM0 17.8824C0 18.4971 0.482143 19 1.07143 19H13.9286C14.5179 19 15 18.4971 15 17.8824C15 17.2676 14.5179 16.7647 13.9286 16.7647H1.07143C0.482143 16.7647 0 17.2676 0 17.8824Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload2);
export default __webpack_public_path__ + "static/media/icon-download2.3b623698.svg";
export { ForwardRef as ReactComponent };